// extracted by mini-css-extract-plugin
export default {"Emoji":"bbq_a bhs_i bhs_q bhs_j"};